import React, { Component } from 'react';
import {connect} from 'react-redux';
import {push, replace} from 'react-router-redux';
import './SubmitTips.scss';
import PCView from './PCView';
import Mobile from './Mobile';

const mapActionCreators = {
  push,
  replace,
};

const mapStateToProps = (state, ownProps) => {
  return {
    device: state.device.current
  }
};

class SubmitTips extends Component {

  state = {
    
  }


  componentWillMount() {
  }

  componentDidMount() {
  }

  componentWillReceiveProps(newProps){
  }

  componentWillUnmount(){
  }

  render = () => {
    const { device } = this.props;
    const props = this.props;
    return <>
      {device === 'pc' && <PCView {...props}/> }
      {device !== 'pc' && <Mobile {...props}/> }
    </>
  }
}

export default connect(mapStateToProps, mapActionCreators)(SubmitTips);
